export default "__VITE_ASSET__nHbgj2Wr__"